import api from './api.js';

export interface CompanyWorkspace {
  id: number;
  name: string;
  email?: string;
  role?: string;
  verified?: boolean;
  active?: boolean;
  isPersonal?: boolean;
  isPlatformOwner?: boolean;
  relationship?: 'member' | 'contractor';
}

export function workspaceLabel(workspace: CompanyWorkspace): string {
  if (workspace.isPlatformOwner) {
    return `${workspace.name} (Platform)`;
  }
  if (workspace.isPersonal) {
    return `${workspace.name} (Personal)`;
  }
  return workspace.name;
}

export async function fetchCompanyWorkspaces(): Promise<CompanyWorkspace[]> {
  const response = await api.get('/company/workspaces');
  const data = response.data?.data ?? response.data;
  return Array.isArray(data) ? data : [];
}

export async function switchCompanyWorkspace(companyId: number | null): Promise<number | null> {
  const response = await api.post('/auth/company/switch', { companyId });
  const payload = response.data?.data;
  const resolved =
    payload?.activeCompanyId ?? payload?.company_id ?? payload?.companyId ?? companyId;
  if (resolved == null || resolved === '') {
    return null;
  }
  return Number(resolved);
}
